// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC5OlRiXfm7V7kcqgXhgg0Xl4ErSMw4Lzs",
    authDomain: "cursoangular4-1516112349964.firebaseapp.com",
    databaseURL: "https://cursoangular4-1516112349964.firebaseio.com",
    projectId: "cursoangular4-1516112349964",
    storageBucket: "cursoangular4-1516112349964.appspot.com",
    messagingSenderId: "4167824223",
 },
};



// WEBPACK FOOTER //
// C:/Users/xikoo/Desktop/cursoAngular4/src/environments/environment.ts